import React from 'react'
import { Helmet } from 'react-helmet-async';
import cn from "classnames";

function Page404 (props) {

  return (
    <div className="static">
      <Helmet>
        <title>404 - yesloyal</title>

        <meta charSet="utf-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon-16x16.png"/>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
      </Helmet>

      <main className='container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '95vh' }}>
        <header className={cn('header')} style={{ justifyContent: 'center', marginBottom: '40px' }}>
          <a href="/">
            <img src="/logo.png" alt="yesloyal" height='52'/>
          </a>
        </header>
        <section style={{ display: 'flex', flex: 1 }}>
          <img src="/404.svg" alt="404 page" style={{margin: 'auto'}} />
        </section>
      </main>
    </div>
  )
}

export default Page404
